import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api'),
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cardlockr_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses (token expired) — skip for public endpoints
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isPublicEndpoint = url.includes('/auth/login') || url.includes('/auth/signup')
        || url.includes('/auth/forgot-password') || url.includes('/auth/reset-password')
        || url.includes('/auth/verify-2fa') || url.includes('/auth/resend-otp')
        || url.includes('/stripe/');
      if (!isPublicEndpoint) {
        localStorage.removeItem('cardlockr_token');
        localStorage.removeItem('cardlockr_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
